import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import { injectIntl } from 'react-intl';

import showToaster from '../../../helpers/showToaster';
import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';
import { doUploadImageBanner } from '../../../actions/siteadmin/manageImageBanner';
import { doUploadHomeBanner } from '../../../actions/siteadmin/manageHomeBanner';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import defaultPic from '/public/adminIcons/defaultAdmin.svg';

import s from 'react-dropzone-component/styles/filepicker.css';
import t from 'dropzone/dist/min/dropzone.min.css';
import u from '../../../styles/adminDropzone.css'
export class ImageUploadComponent extends Component {

	static defaultProps = {
		djsConfig: {
			dictDefaultMessage: '',
			addRemoveLinks: false,
			uploadMultiple: false,
			acceptedFiles: 'image/jpeg,image/png, image/svg+xml, image/jpg',
			dictMaxFilesExceeded: 'Remove the existing image and try upload again',
			previewsContainer: false,
			hiddenInputContainer: '.dzInputContainerLogo',
			timeout: 300000,
			maxFiles: 1
		}
	};

	constructor(props) {
		super(props);
		this.dropzone = null;
	}

	componentDidUpdate() {
		const isBrowser = typeof window !== 'undefined';
		const isDocument = typeof document !== undefined;
		if (isBrowser && isDocument) {
			document.querySelector(".dz-hidden-input").style.visibility = 'visible';
			document.querySelector(".dz-hidden-input").style.opacity = '0';
			document.querySelector(".dz-hidden-input").style.cursor = 'pointer';
		}
	}

	error = async (file) => {
		const { setLoaderComplete, loaderName } = this.props;

		if (loaderName) setLoaderComplete(loaderName);

		this.dropzone.removeFile(file);
	};

	complete = (file) => {
		const { setLoaderComplete, loaderName } = this.props;
		this.dropzone.files = [];
		if (loaderName) setLoaderComplete(loaderName);
	}

	success = async (file, fromServer) => {
		const { doUploadImageBanner, image, multipleHomeBanner, doUploadHomeBanner, demoRestriction } = this.props;
		let fileName, oldImage;
		fileName = fromServer.file.filename;
		oldImage = image != undefined ? image : null;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		multipleHomeBanner ? await doUploadHomeBanner(fileName, oldImage) : await doUploadImageBanner(fileName, oldImage);
		this.dropzone.removeFile(file);
	}


	addedfile = async (file) => {
		const { setLoaderStart, loaderName, fieldName, setLoaderComplete, maxUploadSize, acceptedTypes } = this.props;
		let isOnline = typeof window !== 'undefined' && window.navigator.onLine;

		if (loaderName) setLoaderStart(loaderName);

		if (!isOnline) {
			showToaster({ messageId: 'offlineError', toasterType: 'error' })
			this.dropzone.removeFile(file);
			if (loaderName) setLoaderComplete(loaderName);
			return;
		}

		let fileTypes = acceptedTypes || (fieldName ? ['image/png'] : ['image/jpeg', 'image/png', 'image/jpg'])

		if (file && (file?.accepted === false || !fileTypes?.includes(file?.type))) {
			showToaster({ messageId: 'fileTypeError', toasterType: 'error' })
			if (loaderName) setLoaderComplete(loaderName);
			this.dropzone.removeFile(file);
			return;
		}

		if (file?.size > (1024 * 1024 * parseInt(maxUploadSize))) {
			showToaster({ messageId: 'limitError', toasterType: 'error' })
			setLoaderComplete(loaderName);
			this.dropzone.removeFile(file);
			return;
		}

		if (loaderName) setLoaderComplete(loaderName);
	}

	render() {
		const { defaultMessage, className, djsConfig, componentConfig, success, imageBanner, placeholder, showPreviewContainer } = this.props;

		let djsConfigData = {};

		if (showPreviewContainer) {
			djsConfigData = {
				dictDefaultMessage: '',
				addRemoveLinks: false,
				uploadMultiple: false,
				acceptedFiles: 'image/jpeg,image/png, image/svg+xml, image/jpg',
				dictMaxFilesExceeded: 'Remove the existing image and try upload again',
				hiddenInputContainer: '.dzInputContainerLogo',
				timeout: 300000,
				maxFiles: 1
			}
		}

		const eventHandlers = {
			init: dz => this.dropzone = dz,
			success: imageBanner ? this.success : success,
			error: this.error,
			complete: this.complete,
			addedfile: this.addedfile
		};
		return (
			<div className={cx('dzInputContainerLogo', !imageBanner ? "adminBtnBaseDropZoneContainer" : "adminBoxBaseDropZoneContainer", className)}>
				<DropzoneComponent
					config={componentConfig}
					eventHandlers={eventHandlers}
					djsConfig={showPreviewContainer ? djsConfigData : { ...djsConfig }}
				>
					{imageBanner && <img src={defaultPic} className='adminBoxBaseDropZoneIcon' alt="PictureImage" />}
					{!imageBanner && defaultMessage}
				</DropzoneComponent>
				{imageBanner && <div className={cx('adminBoxBaseDropZonePlaceholder')}>
					{placeholder}
				</div>
				}
			</div>
		)
	}
}

const mapState = state => ({
	maxUploadSize: state?.siteSettings?.data?.maxUploadSize
});

const mapDispatch = {
	setLoaderStart,
	setLoaderComplete,
	doUploadImageBanner,
	doUploadHomeBanner,
	demoRestriction
};

export default injectIntl(withStyles(s, t, u)(connect(mapState, mapDispatch)(ImageUploadComponent)));

